import {createSlice} from '@reduxjs/toolkit'
import {
  _updateDevice,
  _getDeviceList,
  _getDeviceWithHistory,
  _getInmateDeviceHistory,
} from './device.actions'
import {addAPICases} from '../api.helpers'
import {
  ApiPaginationRequestState,
  ApiRequestState,
  apiRequestPaginationStateDefault,
  apiRequestStateDefault,
} from '../api.types'
import {Device, DeviceHistory} from '../openapi'

type DeviceStateType = {
  list: ApiPaginationRequestState<Device[]>
  selected: ApiRequestState<Device>
  inmateHistory: ApiPaginationRequestState<DeviceHistory[]>
  updated: ApiRequestState<Device>
}

const initialState: DeviceStateType = {
  list: {...apiRequestPaginationStateDefault},
  selected: {...apiRequestStateDefault},
  inmateHistory: {...apiRequestStateDefault},
  updated: {...apiRequestStateDefault},
}

export const devices = createSlice({
  name: 'devices',
  initialState: initialState,
  extraReducers: (builder) => {
    addAPICases(builder, _getDeviceList, 'list')
    addAPICases(builder, _getDeviceWithHistory, 'selected')
    addAPICases(builder, _getInmateDeviceHistory, 'inmateHistory')
    addAPICases(builder, _updateDevice, 'updated')
  },
  reducers: {},
})

export default devices.reducer
